<script>
import {defineComponent} from 'vue'
import Detail from "@/pages/customerEnterprise/productCenter/components/detail.vue";

export default defineComponent({
  name: "list",
  components: {Detail},
  data() {
    return {
      loading: true,
      tableData: [],
      payVisible: false,
      payList: {
        buyCount: 1,
        payType: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$http.get(this.$api.customerEnterprise.getKqBuyCloudSealService).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.loading = false;
        } else {
          this.$message.error(res.data.msg);
          this.loading = false
        }
      })
    },
    // 购买商品
    handleBuy(item) {
      this.$confirm(`确认购买 ${item.productName}，价格：¥${item.productPrice}？`, '购买确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.detail.open(item, this.payList)
      }).catch(() => {

      })
    },
    // 查看详情
    handleDetail(item) {
      this.$message.info(`商品详情：${item.productName}`)
    }
  }
})
</script>

<template>
  <div class="app-container">

    <div v-loading="loading" class="product-list">
      <div
          v-for="item in tableData"
          :key="item.productId"
          class="product-item flex-dir-center"
      >
        <div class="product-area flex-dir">
          <img class="product-img" src="@/assets/user/client.png" alt=""/>
          <div class="fz16 mt10">{{ item.productName }}</div>
          <div class="fz14 fc6 mt5">{{ item.remark || '暂无描述' }}</div>
        </div>
        <div class="product-bottom">
          <div class="price-area">
            <span class="price-label">价格：</span>
            <span class="price-value">¥{{ item.productPrice }}</span>
          </div>
          <div class="flex-center-end">
            <!--            <el-button-->
            <!--                type="text"-->
            <!--                size="small"-->
            <!--                @click="handleDetail(item)"-->
            <!--            >-->
            <!--              详情-->
            <!--            </el-button>-->
            <el-button
                type="primary"
                size="small"
                @click="handleBuy(item)"
            >
              购买
            </el-button>
          </div>
        </div>
      </div>

      <div v-if="!loading && tableData.length === 0" class="empty-area">
        <!--        <img src="@/assets/empty.png" alt="" class="empty-img"/>-->
        <div class="empty-text">暂无商品数据</div>
      </div>
    </div>


    <detail ref="detail"/>
  </div>
</template>

<style scoped lang="less">
.title {
  border-top: 6px solid #407fff;
  width: 106px;
  font-weight: 400;
  font-size: 26px;
  color: #000;
  padding-top: 12px;
}

.product-list {
  padding: 35px;
  min-height: 400px;

  .product-item {
    width: 230px;
    height: 280px;
    margin: 0 3% 30px 0;
    float: left;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    overflow: hidden;
    background: #fff;
    border-radius: 4px;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
      transition: all 0.3s;
    }

    .product-area {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex: 1;
      border-bottom: 1px solid #ebebeb;
      padding: 20px 0;
    }

    .product-img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }

    .product-bottom {
      padding: 15px;
      width: 100%;

      .price-area {
        text-align: center;
        margin-bottom: 15px;

        .price-label {
          font-size: 14px;
          color: #666;
        }

        .price-value {
          font-size: 20px;
          color: #f56c6c;
          font-weight: bold;
        }
      }
    }
  }

  .empty-area {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 0;

    .empty-img {
      width: 200px;
      height: 200px;
      object-fit: contain;
    }

    .empty-text {
      margin-top: 20px;
      font-size: 14px;
      color: #999;
    }
  }
}
</style>
